import { useEffect, useRef } from 'react';

import { AnimationShell, Container } from '@/components';
import { useSendServiceStats } from '@/features/stats';
import { cn } from '@/utils/styles';

import { ServiceDetails } from '../../types';

import { ServiceContact } from './service-contact';
import { ServiceCredentials } from './service-credentials';
import { ServiceDescription } from './service-description';
import { ServiceDocuments } from './service-documents';
import { ServiceItems } from './service-items';
import { ServiceLogo } from './service-logo';

export type ServiceContentProps = {
  readonly service: ServiceDetails;
};

export function ServiceContent({ service }: ServiceContentProps) {
  const sendViewStats = useSendServiceStats({ type: 'view' });
  const hasSentStats = useRef(false);

  useEffect(() => {
    if (!service) return;
    if (!hasSentStats.current) {
      sendViewStats(service.id);
      hasSentStats.current = true;
    }
  }, []);

  return (
    <div className="flex flex-col gap-12 p-6 lg:flex-row lg:p-12">
      <AnimationShell type="opacity" className={cn('w-full shrink-0 space-y-12 lg:w-3/5')}>
        <ServiceDescription service={service} />
        <ServiceItems service={service} />
        <ServiceDocuments service={service} />
        <ServiceCredentials service={service} />
      </AnimationShell>
      <AnimationShell type="opacity" className="w-full shrink-0 lg:w-2/5">
        <div className="space-y-12 border-t-2 border-neutral-50 pt-10 lg:ml-10 lg:border-t-0 lg:border-l-2 lg:pt-0 lg:pl-10">
          <ServiceLogo service={service} />
          <ServiceContact service={service} />
        </div>
      </AnimationShell>
    </div>
  );
}
